import baseScmService from 'services/baseScmService';

const skillAssociationService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    updateSkillAssociation: build.mutation({
      query: ({ academyTopicId, courseGroup }) => ({
        method: 'POST',
        url: `/academy-topics/${academyTopicId}/skill-associations/`,
        body: {
          skill_associations: {
            course_group: courseGroup,
          },
        },
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateSkillAssociationMutation } = skillAssociationService;

export default skillAssociationService;
